import Accordion from "./accordion";
import data from "./accordion-data.json";
import styles from "./contact-us.module.scss";
import GoogleMapComponent from "./map";
import StoreDetails from "./store-details";
import Subscription from "./subscription";
const ContactUs = () => {
  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["left"]}>
          <div className={styles["form-section"]}>
            <Subscription />
          </div>
        </div>
        <div className={styles["right"]}>
          <StoreDetails />
          <div className={styles["accordion-container"]}>
            {data.map((item: any, key: any) => {
              if (item.content) {
                return (
                  <Accordion
                    key={key}
                    title={item.title}
                    content={item.content}
                  />
                );
              } else {
                return (
                  <Accordion
                    key={key}
                    title={item.title}
                    memberships={item.memberships}
                    ending_lable={item.ending_lable}
                  />
                );
              }
            })}
          </div>
        </div>
      </div>
      <div className={styles["map-container"]}>
        <GoogleMapComponent
          center={{ lat: 32.7091321, lng: -117.1553064 }}
          zoom={14}
        />
      </div>
    </>
  );
};

export default ContactUs;
